var map = {
	"./common-en.json": 9107,
	"./common-heb.json": 1815,
	"./common-my.json": 6422,
	"./common-ru.json": 8405,
	"./common-th.json": 7708,
	"./common-ua.json": 9510,
	"./en-new.json": 6296,
	"./en.json": 9615,
	"./heb-new.json": 9903,
	"./heb.json": 9987,
	"./my-new.json": 801,
	"./my.json": 6938,
	"./ru-new.json": 3802,
	"./ru.json": 665,
	"./th-new.json": 1407,
	"./th.json": 8723,
	"./ua-new.json": 7889,
	"./ua.json": 1370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9215;